<template>
  <div class="bed-size-list">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="mb-0">{{ $t('bed_sizes.title') }}</h2>
      <b-button variant="primary" @click="createBedSize">
        <i class="fas fa-plus mr-2"></i>{{ $t('bed_sizes.create_button') }}
      </b-button>
    </div>
    <CrudTable
      :columns="fields"
      :data-sources="bedSizes"
      :pagination="paginationInfo"
      :loader="isLoading"
      list-url="/bed-sizes"
      @search="handleSearch"
      @filter="handleFilter"
      @refresh="fetchBedSizes"
    >
      <template #cell(name)="data">
        <div class="font-weight-bold">{{ data.item.name || 'N/A' }}</div>
      </template>
      <template #cell(is_active)="data">
        <div>{{ data.item.is_active ? $t('bed_sizes.status_active') : $t('bed_sizes.status_inactive') }}</div>
      </template>
      <template #cell(actions)="data">
        <div class="d-flex gap-2">
          <b-button
            variant="outline-primary"
            size="sm"
            @click="editBedSize(data.item)"
          >
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button
            variant="outline-danger"
            size="sm"
            @click="confirmDelete(data.item)"
          >
            <i class="fas fa-trash"></i>
          </b-button>
        </div>
      </template>
    </CrudTable>
    <b-modal
      v-model="showDeleteModal"
      :title="$t('bed_sizes.delete_modal_title')"
      @ok="handleDelete"
      ok-variant="danger"
    >
      {{ $t('bed_sizes.delete_modal_message') }}
    </b-modal>
  </div>
</template>

<script>
import { request } from "@/Util/Request";
import CrudTable from "@/components/CrudTable.vue";

export default {
  name: "BedSizeList",
  components: {
    CrudTable,
  },
  data() {
    return {
      bedSizes: [],
      isLoading: false,
      showDeleteModal: false,
      selectedBedSize: null,
      currentPage: 1,
      perPage: 10,
      sortBy: "created_at",
      sortDesc: true,
      filters: {
        search: "",
        status: null,
      },
      fields: [
        { key: "name", label: this.$t("bed_sizes.table_header_name"), sortable: true, sortDirection: "asc" },
        { key: "is_active", label: this.$t("bed_sizes.table_header_status"), sortable: true, sortDirection: "asc" },
        { key: "actions", label: this.$t("common.actions") },
      ],
      statusOptions: [
        { value: null, text: this.$t("bed_sizes.status_all") },
        { value: 1, text: this.$t("bed_sizes.status_active") },
        { value: 0, text: this.$t("bed_sizes.status_inactive") },
      ],
      paginationInfo: {
        from: 0,
        to: 0,
        total: 0,
      },
    };
  },
  methods: {
    handleSearch(search) {
      this.filters.search = search;
      this.currentPage = 1;
      this.fetchBedSizes();
    },
    handleFilter(filter) {
      this.filters = { ...this.filters, ...filter };
      this.currentPage = 1;
      this.fetchBedSizes();
    },
    createBedSize() {
      this.$router.push("/admin/bed-sizes/create");
    },
    editBedSize(bedSize) {
      this.$router.push(`/admin/bed-sizes/${bedSize.id}/edit`);
    },
    confirmDelete(bedSize) {
      this.selectedBedSize = bedSize;
      this.showDeleteModal = true;
    },
    async handleDelete() {
      try {
        await request({
          method: "delete",
          url: `/bed-sizes/${this.selectedBedSize.id}`,
        });
        this.fetchBedSizes();
      } catch (error) {
        console.error("Error deleting bed size:", error);
      }
    },
    async fetchBedSizes() {
      try {
        this.isLoading = true;
        const response = await request({
          method: "get",
          url: "/bed-sizes",
          params: {
            page: this.currentPage,
            per_page: this.perPage,
            sort_by: this.sortBy,
            sort_desc: this.sortDesc,
            ...this.filters,
          },
        });
        if (response.data && response.data.data) {
          this.bedSizes = response.data.data;
          if (response.data.meta) {
            this.paginationInfo = {
              from: response.data.meta.from || 0,
              to: response.data.meta.to || 0,
              total: response.data.meta.total || 0,
            };
          }
        } else {
          this.bedSizes = [];
          this.paginationInfo = {
            from: 0,
            to: 0,
            total: 0,
          };
        }
      } catch (error) {
        console.error("Error fetching bed sizes:", error);
        this.bedSizes = [];
        this.paginationInfo = {
          from: 0,
          to: 0,
          total: 0,
        };
      } finally {
        this.isLoading = false;
      }
    },
  },
  created() {
    this.fetchBedSizes();
  },
};
</script>

<style scoped>
.bed-size-list {
  padding: 20px;
}
</style> 